import goalsRaw from '../../../data/goals/index.json';

export type Goal = { id: string; label: string; icon: string };
export const GOALS: Goal[] = (goalsRaw as { goals: Goal[] }).goals;
export const GOAL_BY_ID: Record<string, Goal> = Object.fromEntries(GOALS.map((g) => [g.id, g]));
